'use strict';
import noop from 'lodash/noop';
import {SCOPE_DESTROY} from '../config/constants/view-events';

MainMenuController.$inject = [
  '$rootScope',
  '$scope',
  '$model',
  '$permissions',
  'AuthService',
  'currentUser',
  'userMetricsService',
];

const VIEW_ACTIONS = {
  canViewForms: 'organization_forms_create', /* Gate view behind the edit permission? */
};

export function MainMenuController(
  $rootScope,
  $scope,
  $model,
  $permissions,
  AuthService,
  currentUser,
  userMetricsService,
) {
  $scope.registerCloseMenu = registerCloseMenu;
  $scope.onCloseMenu = noop;

  init();

  $permissions.bindOrg($scope, $scope, VIEW_ACTIONS);

  function init() {
    // TODO(redux): Replace all usage of this ($scope.model)
    Object.defineProperty($scope, 'model', {value: $model});

    const userMetricsCleanup = userMetricsService.init(currentUser);

    // TODO(redux): Move to redux system and move state loading to MainMenuContainer
    // eslint-disable-next-line max-len
    const conversationCleanup = $rootScope.$on(userMetricsService.NewConversationEvent, $scope.$bindSafeApply(onChatUpdate));
    // eslint-disable-next-line max-len
    const priorityCleanup = $rootScope.$on(userMetricsService.NewPriorityEvent, $scope.$bindSafeApply(onPriorityUpdate));

    $scope.$on(SCOPE_DESTROY, function cleanup() {
      userMetricsCleanup();
      conversationCleanup();
      priorityCleanup();
    });
  }

  function registerCloseMenu(onCloseMenu) {
    $scope.onCloseMenu = onCloseMenu;
  }

  function onChatUpdate($event, metric) {
    $scope.unseenChat = metric ? !metric.isRead : false;
  }

  function onPriorityUpdate($event, metric) {
    $scope.unseenPriority = metric ? !metric.isRead : false;
  }
}



// WEBPACK FOOTER //
// ./src/js/app/MainMenuController.js